import React from "react";
import {
	Alert,
	Box,
	Button,
	Typography,
} from "@mui/material";
import { TextFieldControl } from "@haohan/form-ui"
import { useForm } from "react-hook-form"
import { papi } from "@haohan-frontend/papi";
import { useParams } from "react-router-dom";

import { AuthSetupPasswordFormSuccess } from "../Success/Success";
import { SiteRouterLink } from "../../../../components/RouterLink";
import { useI18n } from "../locales";

const passswordMinLength = 8;

interface Props {
	onSuccess: () => void
}

export function AuthSetupPasswordForm(props: Props) {
	const { token } = useParams<'token'>();
	// const [ success, setSuccess ] = React.useState(true);
	const [ invalidToken, setInvalidToken ] = React.useState(false);
	const { t, Trans } = useI18n();
	const { control, formState, getValues, handleSubmit } = useForm({
		defaultValues: {
			password: '',
			repeatPassword: '',
		},
		mode: 'onTouched',
	});
	const submitForm = handleSubmit(async () => {
		const values = getValues();
		const res = await papi.auth.setupPassword({...values, token});
		if (res.success) {
			props.onSuccess();
		} else {
			if (res.errors?.invalidToken) {
				setInvalidToken(true);
			}
		}
	});
	return (
		<Box position='relative'>
			<Typography
				color='textSecondary'
				display='block'
				mb={3}
				textAlign='center'
				variant='body2'
			>
				{t("actions.Input new password bellow")}
			</Typography>

			{invalidToken && (
				<Box mb={1}>
					<Alert severity="error">
						<Trans
							i18nKey="errors.link_expired"
							components={[
								<SiteRouterLink
									to='/auth/password/forgot'
									underline='hover'
								/>
							]}
						/>
					</Alert>
				</Box>
			)}
			<form onSubmit={submitForm}>
				<TextFieldControl
					autoComplete='current-password'
					control={control}
					fullWidth
					label={t('Password')}
					margin='normal'
					name='password'
					rules={{
						required: t('errors.Required field'),
						deps: 'repeatPassword',
						minLength: {
							value: passswordMinLength,
							message: t('errors.password_min_length', {count: passswordMinLength})
						}
					}}
					size='small'
					type='password'
					variant='outlined'
				/>
				<TextFieldControl
					autoComplete='current-password'
					control={control}
					fullWidth
					label={t("Repeat password")}
					margin='normal'
					name='repeatPassword'
					rules={{
						required: t('errors.Required field'),
						validate(v) {
							if (getValues().password !== v) {
								return t('errors.password_not_match')
							}
						}
					}}
					size='small'
					type='password'
					variant='outlined'
				/>

				<Box mt={5}>
					<Button
						disabled={formState.isSubmitting}
						fullWidth
						type='submit'
						variant='contained'
					>
						{t('actions.Setup password')}
					</Button>
				</Box>
			</form>
		</Box>
	);
}
